// Skeleton for campaign details only (image, title, description)
export function CampaignDetailsSkeleton() {
  return (
    <section className={'mx-auto w-full max-w-[calc(100%_-_2rem)]'}>
      <div className="flex animate-pulse flex-col gap-y-6">
        {/* Image skeleton */}
        <div className="aspect-video max-h-44 w-full overflow-clip rounded-2xl bg-gray-200 p-0 lg:max-h-64" />

        {/* Title skeleton */}
        <div className="flex flex-col gap-y-2 px-4">
          <div className="h-6 w-3/4 rounded bg-gray-200"></div>
        </div>
      </div>

      {/* Description skeleton */}
      <div className="mt-4 flex animate-pulse flex-col gap-y-4 px-4">
        <div className="space-y-2">
          <div className="h-4 w-full rounded bg-gray-200"></div>
          <div className="h-4 w-full rounded bg-gray-200"></div>
          <div className="h-4 w-2/3 rounded bg-gray-200"></div>
        </div>
      </div>
    </section>
  );
}

// Skeleton for rewards section only
export function RewardsSkeleton() {
  return (
    <div className="mt-4 px-4">
      <div className="flex animate-pulse flex-col gap-y-3">
        <div className="h-5 w-1/3 rounded bg-gray-200"></div>
        <div className="space-y-2">
          {Array.from({ length: 2 }).map((_, index) => (
            <div
              key={`reward-skeleton-${index}`}
              className="flex items-center space-x-3"
            >
              <div className="h-12 w-12 rounded-full bg-gray-200"></div>
              <div className="flex-1 space-y-1">
                <div className="h-4 w-3/4 rounded bg-gray-200"></div>
                <div className="h-3 w-1/2 rounded bg-gray-200"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// Full skeleton for when both are loading (backwards compatibility)
export default function CampaignDetailsFullSkeleton() {
  return (
    <>
      <CampaignDetailsSkeleton />
      <RewardsSkeleton />
    </>
  );
}
